import { atom } from "recoil";
import { IType } from "../types";

export const addStateType = atom({
  key: "addStateType",
  default: false,
});
export const editStateType = atom({
  key: "editStateType",
  default: false,
});
export const rowEditType = atom<IType | undefined>({
  key: "rowEditType",
  default: undefined,
});

export const selectedRowsStateType = atom<IType[]>({
  key: "selectedRowsStateType",
  default: [],
});

export const typeFilterText = atom({
  key: "typeFilterText",
  default: "",
});

export const savingType = atom({
  key: "savingType",
  default: false,
});
export const typeFetching = atom({
  key: "typeFetching",
  default: true,
});
